import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { HeartPulse, Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (admin && admin !== false) navigate("/admin");
  }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 grid place-items-center px-5">
      <div className="w-full max-w-sm rounded-3xl bg-white p-8 border border-slate-200">
        <div className="tricolor-bar h-1 w-16 rounded-full mb-6" />
        <div className="flex items-center gap-2.5 mb-6">
          <span className="grid place-items-center w-10 h-10 rounded-lg bg-[#0056D2] text-white"><HeartPulse className="w-5 h-5" /></span>
          <div>
            <p className="font-display font-extrabold text-slate-900 leading-none">Admin Console</p>
            <p className="text-xs text-slate-500">Healthy India Pledge Wall</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="a-email" className="text-sm font-medium text-slate-700">Email</Label>
            <Input data-testid="admin-email" id="a-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" required />
          </div>
          <div>
            <Label htmlFor="a-pass" className="text-sm font-medium text-slate-700">Password</Label>
            <Input data-testid="admin-password" id="a-pass" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" required />
          </div>
          <Button data-testid="admin-login-btn" type="submit" disabled={loading} className="w-full rounded-full bg-[#0056D2] hover:bg-blue-700 text-white font-semibold h-11">
            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Signing in…</> : <><ShieldCheck className="w-4 h-4 mr-2" /> Sign in</>}
          </Button>
        </form>
      </div>
    </div>
  );
}
